import axios from 'axios';
import { AUTH_PROVIDER_HEADER } from '@onesource/schemas';
import { getActiveAuthProvider } from '../common/auth/auth-provider-utils';

const MEMBERS_API_URL = import.meta.env.VITE_MEMBERS_API_ENDPOINT;

const learningCenterAxios = axios.create({
  baseURL: MEMBERS_API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth header interceptor
learningCenterAxios.interceptors.request.use(config => {
  try {
    const authProvider = getActiveAuthProvider();
    config.headers[AUTH_PROVIDER_HEADER] = authProvider;

    // Get token from localStorage
    const token = localStorage.getItem('session');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // Skip if localStorage not available
  }
  return config;
});

export default learningCenterAxios;
